<div class="modal-header">
  <h3 class="modal-title">{{ config.modalTitle }}</h3>
  <div class="header-actions">
    @if (config.showMinimize !== false) {
<i 
       class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
}
    <i (click)="onClose()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Loader -->
@if (loading) {
<div class="loading-container" style="text-align: center; padding: 50px;">
  <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
</div>
}

<!-- Modal Body -->
@if (!loading) {
<div [hidden]="minimise">
  <div class="modal-body-content">
    @if (config.confirmationMessage) {
<div class="confirm-message">
      <h5>
        <i class="fa fa-exclamation-triangle"></i>
        {{ config.confirmationMessage }}
      </h5>
    </div>
}
  </div>
</div>
}

<!-- Modal Footer -->
@if (!loading) {
<div [hidden]="minimise" class="modal-footer">
  <button class="delete-button" 
          type="button" 
          [disabled]="loading" 
          (click)="onConfirmAction()">
    @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}{{ config.confirmButtonText || 'Confirm' }}
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="onCancel()">{{ config.cancelButtonText || 'Cancel' }}</button>
</div>
}

